<div class="not_added" *ngIf="emptyMsg">
  <div class="user_img"><img src="./assets/img-new/device.png" alt="Device"></div>
  <h4>No device added yet</h4>
  <button mat-raised-button color="primary" (click)="addNewDevice()">
    <span class="sprite_icon plus_white"></span>
    <span>Add Device</span>
  </button>
</div>

<div *ngIf="showList">
  <div class="breadcrumb_outer">
    <ul class="breadcrumb">
      <li class="active"><a>Device</a></li>
    </ul>
    <div class="right"><span>{{today}}</span></div>
  </div>
  <div class="tag_powered_by">
    <span>Powered by: <b>Enertics</b></span>
  </div>
  <div class="Content_outer">
      <div class="content_view">
          <div class="row">
            <div class="col-md-12">
                <div class="listing_outer device_list">
                      <div class="filter_div">
                          <div class="top">
                              <h4>Device Type</h4>
                              <div class="right">
                              <button mat-raised-button color="primary" (click)="addNewDevice()">
                                <span class="sprite_icon plus_white"></span>
                                <span>Add Device</span>
                              </button>
                                  <div class="" [ngStyle]="{'height':'30px','position':'relative'}">
                                    <input  [formControl]="mac_address" placeholder="MAC Address" class="form-control" [ngStyle]="{'height':'30px'}" >
                                    <mat-icon [ngStyle]="
                                        {'position': 'absolute',
                                          'top': '4px',
                                          'right': '5px'}">search</mat-icon>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div class="no_result" style="display: none"></div>
                      @if (filterDeviceArrayList.length) {
                      <div class="listing_box three_col heading">
                       <h4 class="left">Name</h4>
                       <h4 class="center">Available Inventories</h4>
                       <h4 class="right"></h4>
                      </div>
                      <div class="listing_box three_col" *ngFor="let device of filterDeviceArrayList;trackBy: trackByFn; let i = index;">

                          <div class="left">
                              <h4>{{device.name}}</h4>
                              <p>({{device.detail}})</p>
                          </div>
                          <div class="center">
                              <div class="import_div">
                                <span>{{device?.device_inventory_count || '0'}}</span>
                                <div class="rg">
                                  <div class="links">
                                    <div class="upload-icon-wrapper">
                                      <span><a class="link_btn">Import</a></span>
                                      <input type="file" name="myfile" accept=".csv" ng2FileSelect [uploader]="uploader" (change)="upload($event.target.files, device.id)">
                                    </div>
                                      <a class="link_btn" (click)="viewInventoriesFilteredClick(device.id, device.name, device.detail, device.device_category_id)">View</a>
                                  </div>
                                  <div class="error_msg m_t_5" style="display: none">Please check the required column(s) are present for inventories (Device serial and Mac address)</div>
                                </div>
                              </div>
                          </div>
                          <div class="actions dropdown right">
                              <button class="btn dropdown-toggle" type="button" [matMenuTriggerFor]="menu" data-toggle="dropdown">
                                <span class="sprite_icon ellipse_black"></span>
                              </button>
                              <mat-menu #menu="matMenu">
                                <div style="width: 100% !important;"  class="menu-item-container">
                                  <button mat-stroked-button color="primary" (click)="editInfo(device, i)" style="width: 100% !important;" class="edit-button">
                                    <mat-icon>edit</mat-icon>
                                    <span>Edit</span>
                                  </button>
                                </div>
                                <div style="width: 100% !important;"  class="menu-item-container">
                                  <button mat-stroked-button color="warn" (click)="deleteNewDeviceDialogBox(device, i)" class="delete-button">
                                    <mat-icon>delete</mat-icon>
                                    <span>Delete</span>
                                  </button>
                                </div>
                                <div class="menu-item-container" *ngIf="device.config_mapping === 'yes'">
                                  <button mat-stroked-button (click)="showMappingConfig(device, i)">
                                    <mat-icon>settings</mat-icon>
                                    <span>Show Mapping Config</span>
                                  </button>
                                </div>
                              </mat-menu>

                          </div>
                      </div>
                    }

                      <div class="listing_box three_col heading">
                       <h4 class="left">Name</h4>
                       <h4 class="center">Available Inventories</h4>
                       <h4 class="right"></h4>
                      </div>
                      <div class="listing_box three_col" *ngFor="let device of deviceTypeList;trackBy: trackByFn; let i = index;">

                          <div class="left">
                              <h4>{{device.name}}</h4>
                              <p>({{device.detail}})</p>
                          </div>
                          <div class="center">
                              <div class="import_div">
                                <span>{{device?.device_inventory_count || '0'}}</span>
                                <div class="rg">
                                  <div class="links">
                                    <div class="upload-icon-wrapper">
                                      <span><a class="link_btn">Import</a></span>
                                      <input type="file" name="myfile" accept=".csv" ng2FileSelect [uploader]="uploader" (change)="upload($event.target.files, device.id)">
                                    </div>
                                      <a class="link_btn" (click)="viewInventories(device.id, device.name, device.detail, device.device_category_id,device)">View</a>
                                  </div>
                                  <div class="error_msg m_t_5" style="display: none">Please check the required column(s) are present for inventories (Device serial and Mac address)</div>
                                </div>
                              </div>
                          </div>
                          <div class="actions dropdown right">
                              <button class="btn dropdown-toggle" type="button" [matMenuTriggerFor]="menu" data-toggle="dropdown">
                                <span class="sprite_icon ellipse_black"></span>
                              </button>
                              <mat-menu #menu="matMenu">
                                <div style="width: 100% !important;" class="menu-item-container">
                                  <button mat-stroked-button color="primary" (click)="editInfo(device, i)" style="width: 100% !important;" class="edit-button">
                                    <mat-icon>edit</mat-icon>
                                    <span>Edit</span>
                                  </button>
                                </div>
                                <div style="width: 100% !important;" class="menu-item-container">
                                  <button mat-stroked-button color="warn" (click)="deleteNewDeviceDialogBox(device, i)" style="width: 100% !important;" class="delete-button">
                                    <mat-icon>delete</mat-icon>
                                    <span>Delete</span>
                                  </button>
                                </div>
                                <div class="menu-item-container" *ngIf="device.config_mapping === 'yes'">
                                  <button mat-stroked-button (click)="showMappingConfig(device, i)">
                                    <mat-icon>settings</mat-icon>
                                    <span>Show Mapping Config</span>
                                  </button>
                                </div>
                              </mat-menu>

                          </div>
                      </div>
                </div>
            </div>
          </div>
      </div>
  </div>
</div>
<!-- <mat-menu #menu="matMenu">
  <button mat-menu-item (click)="editClient(clients.id)">Edit</button>
  <button mat-menu-item (click)="showDeleteDialog(clients.id, idx)">Delete</button>
</mat-menu> -->